module.exports = __webpack_public_path__ + "static/iBukt-1d01e9ec36780ca7ffbce505f332ea3a.jpg";